import { useEffect, useState, useCallback, useRef } from "react";
import { whatsappApi } from "../lib/whatsappApi";

/**
 * useWhatsAppStatus — polling leve do status da conexão WhatsApp + contagem
 * de mensagens não lidas. Usado por:
 *   - Sidebar (badge no item WhatsApp)
 *   - Home / buildSystemAlerts (alerta "WhatsApp desconectado")
 *   - Módulo WhatsApp (auto-refresh no card de Conexão)
 *
 * Retorna { status, refresh }. Ignora 401 (usuário deslogado) — só polla se autenticado.
 */
export const useWhatsAppStatus = (intervalMs = 8000) => {
    const [status, setStatus] = useState({ connected: false, unread: 0, phone_number: null, loading: true });
    const timerRef = useRef(null);
    const mountedRef = useRef(true);

    const refresh = useCallback(async () => {
        try {
            const token = typeof window !== "undefined" ? localStorage.getItem("kinng.token") : null;
            if (!token) {
                if (mountedRef.current) setStatus((s) => ({ ...s, loading: false }));
                return;
            }
            const s = await whatsappApi.getStatus();
            if (mountedRef.current) setStatus({ ...s, loading: false });
        } catch (_) {
            if (mountedRef.current) setStatus((s) => ({ ...s, loading: false }));
        }
    }, []);

    useEffect(() => {
        mountedRef.current = true;
        refresh();
        timerRef.current = setInterval(refresh, intervalMs);
        return () => {
            mountedRef.current = false;
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [refresh, intervalMs]);

    return { status, refresh };
};

export default useWhatsAppStatus;
